'use strict';

import FieldView from 'views/record/Field';

class HiddenField extends FieldView {
}

export default HiddenField;
